import { render } from "./CopiarServicoModal.vue?vue&type=template&id=33610b49&ts=true"
import script from "./CopiarServicoModal.vue?vue&type=script&lang=ts"
export * from "./CopiarServicoModal.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/camp/Desktop/code-time/acampa-gestao-pra/vuecode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__